/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Branding_RequiredInputs */

const cs_templates_branding_required = /** @type {(inputs: Templates_Branding_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`povinné`)
};

const en_templates_branding_required = /** @type {(inputs: Templates_Branding_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`required`)
};

/**
* | output |
* | --- |
* | "required" |
*
* @param {Templates_Branding_RequiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_branding_required = /** @type {((inputs?: Templates_Branding_RequiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Branding_RequiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_branding_required(inputs)
	return cs_templates_branding_required(inputs)
});